<template>
  <div @click="show = false">
    <van-notify
      v-model:show="show"
      type="success"
      position="top"
      style="
        padding: 0.05rem 0.3rem;
        border-radius: 0 0 0.16rem 0.16rem;
        border: 0.02rem solid;
        border-color: #c0a967;
        background: black;
        color: white;
      "
    >
      <div class="content">
        <div class="left">
          <img :src="`${resbaseurl}logo-new.png`" alt="logo" class="logo" />
          <div class="username">{{ record ? record.nickname : '' }}</div>
          <div class="deposit-type">
            <p
              class="type-name"
              v-html="
                $t('envelope.popup.fuchuang', {
                  value: record ? formatMoney(record.reward) : '--'
                })
              "
            />
            <!-- <span class="type-amount">ETB 500.00</span> -->
            <div class="type-icon"><i class="bi bi-check-circle-fill"></i></div>
          </div>
        </div>
        <div class="right">
          <div class="time">{{ dayjs(new Date() - 20000).format('MM-DD HH:mm:ss') }}</div>
          <div class="amount-icon">
            <div class="icon-amount">
              {{ record ? formatMoney(record.reward) : '--' }}
              {{ record ? record.currency : balance.currencyAlias }}
            </div>
            <img class="image" :src="`${resbaseurl}deposit_telebirr.png`" alt="" />
            <!--             <img class="image" :src="`${resbaseurl}deposit_telebirr_arifpay.png`" alt="" /> -->
          </div>
        </div>
      </div>
    </van-notify>
  </div>
</template>

<script>
import { config } from '@/common/config'
import { BUS } from '@/event/EventCenter'
import { useEnvelopeStore } from '@/stores/envelope'
import { useUserStore } from '@/stores/user'
import { formatMoney } from '@/utils/helper'
import dayjs from 'dayjs'
import { mapState } from 'pinia'

export default {
  data() {
    return {
      show: false,
      resbaseurl: config.resBaseUrl,
      record: null,
      count: 1,
      timer: null
    }
  },
  watch: {
    isFinishGuide(newvalue) {
      if (newvalue) {
        this.checkNotice()
      }
    }
  },
  mounted() {
    this.count = 0
    setInterval(() => {
      this.checkNotice()
    }, 20000)
    this.$bus.$emit(BUS.SHOW_ENVELOPE_NOTIFY, () => {
      this.checkNotice()
    })
  },
  computed: {
    ...mapState(useEnvelopeStore, ['isFinishGuide', 'noticeRecords']),
    ...mapState(useUserStore, ['balance'])
  },
  methods: {
    dayjs,
    formatMoney,
    checkNotice() {
      if (this.noticeRecords.length > 0 && this.isFinishGuide) {
        this.count++
        this.record = this.noticeRecords[Math.max(0, this.noticeRecords.length - this.count)]
        if (this.count >= this.noticeRecords.length) {
          this.count = 1
        }
        this.show = this.isFinishGuide
        this.timer && clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.show = false
        }, 10000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    height: 100%;
    width: auto;

    .logo {
      width: 2.24rem;
      // height: 0.3rem;
    }

    .username {
      width: auto;
      height: 0.3rem;
      font-family: DroidSans;
      font-size: 0.24rem;
      color: #ffffff;
      line-height: 0.3rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .deposit-type {
      width: auto;
      height: 0.5rem;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .type-name {
        width: auto;
        height: 0.28rem;
        font-family: DroidSans;
        font-size: 0.3rem;
        color: #ffffff;
        line-height: 0.3rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .type-amount {
        color: #ffddac;
        font-weight: Bold;
        font-family: Oswald-Bold;
        font-size: 0.3rem;
        margin-left: 0.1rem;
      }

      .type-icon {
        font-size: 0.24rem;
        color: #27984b;
        margin-left: 0.1rem;
      }
    }
  }

  .right {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .time {
      width: auto;
      height: 0.4rem;
      font-family: DroidSans;
      font-size: 0.24rem;
      color: #ffffff;
      line-height: 0.3rem;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .amount-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 1.5rem;
      height: auto;
      background: #000;
      border-radius: 0.16rem;
      border: 0.02rem solid;
      border-color: #a58f55;
      padding: 0.1rem 0;

      .icon-amount {
        width: auto;
        height: 0.3rem;
        font-family: DroidSans;
        font-size: 0.24rem;
        color: #ffddac;
        line-height: 0.3rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .image {
        width: 0.9rem;
        height: 0.39rem;
      }
    }
  }
}
</style>
